var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182.956,
    height: 223.959,
    viewBox: "0 0 182.956 223.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172565",
    "data-name": "\\uADF8\\uB8F9 172565",
    transform: "translate(1.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M705.013,282.65a1.013,1.013,0,1,0,0,2.026h28.373a1.013,1.013,0,0,0,0-2.026Z",
    transform: "translate(-655.837 -105.661)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121416",
    "data-name": "\\uD328\\uC2A4 121416",
    d: "M0,0Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 13.185, 187.945)",
    fill: "#096473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121421",
    "data-name": "\\uD328\\uC2A4 121421",
    d: "M0,0,.006.025V.015S0,0,0,0Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 23.538, 212.121)",
    fill: "#096473"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172549",
    "data-name": "\\uADF8\\uB8F9 172549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121145",
    "data-name": "\\uD328\\uC2A4 121145",
    d: "M7.234,15.18A7.594,7.594,0,1,0,.009,7.23,7.594,7.594,0,0,0,7.234,15.18Z",
    transform: "matrix(-0.999, 0.035, -0.035, -0.999, 89.808, 15.179)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121146",
    "data-name": "\\uD328\\uC2A4 121146",
    d: "M7.23,15.18A7.594,7.594,0,1,0,.009,7.231,7.595,7.595,0,0,0,7.23,15.18Z",
    transform: "matrix(-0.999, 0.035, -0.035, -0.999, 115.117, 15.511)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121147",
    "data-name": "\\uD328\\uC2A4 121147",
    d: "M7.232,15.18A7.594,7.594,0,1,0,.009,7.23,7.594,7.594,0,0,0,7.232,15.18Z",
    transform: "matrix(-0.999, 0.035, -0.035, -0.999, 140.431, 15.84)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121148",
    "data-name": "\\uD328\\uC2A4 121148",
    d: "M7.231,15.18A7.594,7.594,0,1,0,.009,7.23,7.594,7.594,0,0,0,7.231,15.18Z",
    transform: "matrix(-0.999, 0.035, -0.035, -0.999, 165.745, 16.167)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121152",
    "data-name": "\\uD328\\uC2A4 121152",
    d: "M7.23,15.18A7.594,7.594,0,1,0,.009,7.23,7.594,7.594,0,0,0,7.23,15.18Z",
    transform: "matrix(-0.999, 0.035, -0.035, -0.999, 140.101, 41.153)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121153",
    "data-name": "\\uD328\\uC2A4 121153",
    d: "M7.232,15.18A7.594,7.594,0,1,0,.009,7.231,7.594,7.594,0,0,0,7.232,15.18Z",
    transform: "matrix(-0.999, 0.035, -0.035, -0.999, 165.414, 41.482)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121157",
    "data-name": "\\uD328\\uC2A4 121157",
    d: "M7.23,15.18A7.594,7.594,0,1,0,.009,7.231,7.594,7.594,0,0,0,7.23,15.18Z",
    transform: "matrix(-0.999, 0.035, -0.035, -0.999, 139.77, 66.472)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121158",
    "data-name": "\\uD328\\uC2A4 121158",
    d: "M7.231,15.18A7.594,7.594,0,1,0,.009,7.23,7.594,7.594,0,0,0,7.231,15.18Z",
    transform: "matrix(-0.999, 0.035, -0.035, -0.999, 165.086, 66.797)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121181",
    "data-name": "\\uD328\\uC2A4 121181",
    d: "M1052.893,582.8s5.435,55.264,1.354,156.659L944.9,742.8s2.405-68.485-10.956-154.872Z",
    transform: "translate(-933.946 -562.616)",
    fill: "none",
    stroke: "#f8c44f",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121184",
    "data-name": "\\uD328\\uC2A4 121184",
    d: "M.2,1.035,25.511,0,25.7,1.728,0,3.028Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 44.696, 52.016)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121185",
    "data-name": "\\uD328\\uC2A4 121185",
    d: "M0,.609,16.225,0l.318,2.405L.355,2.851Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 37.097, 80.007)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121186",
    "data-name": "\\uD328\\uC2A4 121186",
    d: "M0,.336,4.633,0l.318,2.406L.36,2.566Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 44.437, 79.256)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121187",
    "data-name": "\\uD328\\uC2A4 121187",
    d: "M0,2.686.257.459,16.768,0l-.239,2.048Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 45.364, 44.615)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121188",
    "data-name": "\\uD328\\uC2A4 121188",
    d: "M0,3.028.276.566,20.565,0,20.3,2.247Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 68.311, 43.67)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121189",
    "data-name": "\\uD328\\uC2A4 121189",
    d: "M0,2.874,1.408.234,9.983,0,9.7,2.494Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 80.643, 42.815)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121190",
    "data-name": "\\uD328\\uC2A4 121190",
    d: "M.239.212,7.7,0l.488,1.915L0,2.232Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 26.193, 45.235)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121191",
    "data-name": "\\uD328\\uC2A4 121191",
    d: "M0,3.195.241,1.161,23.386,0l-.257,2.216Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 71.504, 57.013)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121192",
    "data-name": "\\uD328\\uC2A4 121192",
    d: "M0,2.715.256.463,12.945,0l-.29,2.47Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 45.34, 58.03)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121193",
    "data-name": "\\uD328\\uC2A4 121193",
    d: "M0,2.874.285.369,9.983,0,9.842,1.934Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 30.041, 58.772)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121194",
    "data-name": "\\uD328\\uC2A4 121194",
    d: "M0,2.667.239.623,14.068,0l-.252,2.219Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 89.28, 76.985)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121195",
    "data-name": "\\uD328\\uC2A4 121195",
    d: "M0,2.7.257.464,12.946,0l-.284,2.47Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 72.428, 77.833)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121196",
    "data-name": "\\uD328\\uC2A4 121196",
    d: "M0,2.872.291.373,9.993,0,9.844,1.946Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 57.137, 78.579)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121197",
    "data-name": "\\uD328\\uC2A4 121197",
    d: "M0,2.667.231.617,14.072,0l-.253,2.227Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 95.577, 98.871)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121198",
    "data-name": "\\uD328\\uC2A4 121198",
    d: "M0,2.713.26.451,12.949,0,12.66,2.466Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 78.73, 99.716)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121199",
    "data-name": "\\uD328\\uC2A4 121199",
    d: "M0,2.871.286.374,9.987,0,9.844,1.94Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 63.436, 100.466)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121200",
    "data-name": "\\uD328\\uC2A4 121200",
    d: "M0,3.134.3.555,20.082,0l-.271,2.356Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 54.624, 36.707)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121201",
    "data-name": "\\uD328\\uC2A4 121201",
    d: "M0,3.228.317.455,16.179,0l-.3,2.617Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 73.142, 35.759)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121202",
    "data-name": "\\uD328\\uC2A4 121202",
    d: "M.267.448.073.417,15.138,0,15.7,2.137,0,2.745Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 32.181, 37.585)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121203",
    "data-name": "\\uD328\\uC2A4 121203",
    d: "M0,3.234,1.587.266,11.358,0l-.323,2.8Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 86.817, 34.994)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121204",
    "data-name": "\\uD328\\uC2A4 121204",
    d: "M.2,1.039,25.512,0,25.7,1.736,0,3.028Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 48.603, 101.907)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121205",
    "data-name": "\\uD328\\uC2A4 121205",
    d: "M0,2.691.258.455,16.776,0l-.239,2.048Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 49.282, 94.504)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121206",
    "data-name": "\\uD328\\uC2A4 121206",
    d: "M0,3.032.273.57,20.556,0,20.29,2.256Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 72.216, 93.562)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121207",
    "data-name": "\\uD328\\uC2A4 121207",
    d: "M0,2.871,1.4.235,9.989,0l-.3,2.491Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 84.557, 92.7)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121209",
    "data-name": "\\uD328\\uC2A4 121209",
    d: "M0,3.2.243,1.163,23.385,0l-.25,2.219Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 75.418, 106.9)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121210",
    "data-name": "\\uD328\\uC2A4 121210",
    d: "M0,2.717.254.466,12.939,0l-.28,2.47Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 49.249, 107.92)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121212",
    "data-name": "\\uD328\\uC2A4 121212",
    d: "M0,3.134.294.554,20.081,0l-.272,2.363Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 58.537, 86.598)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121213",
    "data-name": "\\uD328\\uC2A4 121213",
    d: "M0,3.225.324.446,16.178,0l-.3,2.612Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 77.052, 85.649)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121214",
    "data-name": "\\uD328\\uC2A4 121214",
    d: "M.26.452.066.42,15.136,0l.551,2.138L0,2.756Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 36.092, 87.477)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121215",
    "data-name": "\\uD328\\uC2A4 121215",
    d: "M0,3.233,1.588.276,11.351,0l-.315,2.811Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 90.725, 84.889)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121216",
    "data-name": "\\uD328\\uC2A4 121216",
    d: "M0,2.682.251.463,16.763,0l-.232,2.041Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 48.766, 72.775)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121217",
    "data-name": "\\uD328\\uC2A4 121217",
    d: "M0,2.5.289.028,9.4,0,9.14,2.251Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 60.552, 72.027)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121218",
    "data-name": "\\uD328\\uC2A4 121218",
    d: "M0,3.326,1.407.692,18.988,0l-.282,2.5Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 84.053, 71.431)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121219",
    "data-name": "\\uD328\\uC2A4 121219",
    d: "M.232.209,7.687,0l.5,1.9L0,2.222Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 29.595, 73.394)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121220",
    "data-name": "\\uD328\\uC2A4 121220",
    d: "M0,2.977.284.528,19.069,0,18.8,2.244Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 54.376, 65.475)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121221",
    "data-name": "\\uD328\\uC2A4 121221",
    d: "M0,3.055.305.416,15.363,0l-.284,2.474Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 71.954, 64.569)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121222",
    "data-name": "\\uD328\\uC2A4 121222",
    d: "M.248.427.06.4l14.3-.4.528,2.025L0,2.614Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 33.056, 66.313)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121223",
    "data-name": "\\uD328\\uC2A4 121223",
    d: "M0,3.062,1.5.256,10.779,0l-.3,2.659Z",
    transform: "matrix(-1, 0.017, -0.017, -1, 84.929, 63.845)",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M617.806,325.63H499.532c-.759,0-1.374-.918-1.375-2.048V159.932c0-1.131.616-2.047,1.375-2.048H617.806c.759,0,1.374.918,1.375,2.048v163.65c0,1.131-.616,2.047-1.375,2.048Z",
    transform: "translate(-464.266 -115.604)",
    fill: "#f8c44f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153184",
    "data-name": "\\uC0AC\\uAC01\\uD615 153184",
    width: 115.179,
    height: 159.996,
    rx: 6,
    transform: "translate(37.088 46.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M705.013,262.185a1.013,1.013,0,1,0,0,2.026H760.59a1.013,1.013,0,0,0,0-2.026Z",
    transform: "translate(-619.033 -188.773)",
    fill: "#028fa4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142-2",
    "data-name": "Path 142",
    d: "M705.013,262.185a1.013,1.013,0,1,0,0,2.026H760.59a1.013,1.013,0,0,0,0-2.026Z",
    transform: "translate(-655.838 -103.448)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142-3",
    "data-name": "Path 142",
    d: "M705.013,262.185a1.013,1.013,0,1,0,0,2.026H760.59a1.013,1.013,0,0,0,0-2.026Z",
    transform: "translate(-655.838 -91.273)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143-2",
    "data-name": "Path 143",
    d: "M705.013,282.65a1.013,1.013,0,1,0,0,2.026h28.373a1.013,1.013,0,0,0,0-2.026Z",
    transform: "translate(-619.032 -203.16)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143-3",
    "data-name": "Path 143",
    d: "M705.013,282.65a1.013,1.013,0,1,0,0,2.026h28.373a1.013,1.013,0,0,0,0-2.026Z",
    transform: "translate(-655.837 -117.837)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142-4",
    "data-name": "Path 142",
    d: "M541.331,392.7a1.02,1.02,0,0,0,0,2.026h92.66a1.02,1.02,0,0,0,0-2.026Z",
    transform: "translate(-492.269 -280.53)",
    fill: "#028fa4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143-4",
    "data-name": "Path 143",
    d: "M541.444,413.17a1.013,1.013,0,0,0,0,2.026h77a1.013,1.013,0,1,0,0-2.026Z",
    transform: "translate(-492.269 -294.918)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142-5",
    "data-name": "Path 142",
    d: "M541.331,433.172a1.02,1.02,0,0,0,0,2.026h92.66a1.02,1.02,0,0,0,0-2.026Z",
    transform: "translate(-492.269 -308.98)",
    fill: "#028fa4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143-5",
    "data-name": "Path 143",
    d: "M541.444,453.637a1.013,1.013,0,0,0,0,2.026h77a1.013,1.013,0,1,0,0-2.026Z",
    transform: "translate(-492.269 -323.368)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142-6",
    "data-name": "Path 142",
    d: "M541.331,474.172a1.02,1.02,0,0,0,0,2.026h92.66a1.02,1.02,0,0,0,0-2.026Z",
    transform: "translate(-492.269 -337.804)",
    fill: "#028fa4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143-6",
    "data-name": "Path 143",
    d: "M541.444,494.637a1.013,1.013,0,0,0,0,2.026h77a1.013,1.013,0,1,0,0-2.026Z",
    transform: "translate(-492.269 -352.191)",
    fill: "#50b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121054",
    "data-name": "\\uD328\\uC2A4 121054",
    d: "M562.532,251.054a12.113,12.113,0,1,1,12.113-12.113A12.113,12.113,0,0,1,562.532,251.054Z",
    transform: "translate(-496.852 -161.477)",
    fill: "#038fa4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121067",
    "data-name": "\\uD328\\uC2A4 121067",
    d: "M581.3,265.975a.775.775,0,0,1-.529-.208l-3.589-3.334a.778.778,0,1,1,1.058-1.139l3.04,2.824L587.3,258.1a.778.778,0,1,1,1.1,1.1l-6.545,6.545A.775.775,0,0,1,581.3,265.975Z",
    transform: "translate(-517.098 -184.462)",
    fill: "#ff3364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121226",
    "data-name": "\\uD328\\uC2A4 121226",
    d: "M0,0H0Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 38.813, 132.392)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121227",
    "data-name": "\\uD328\\uC2A4 121227",
    d: "M0,0V.039H.041Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 35.549, 136.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121228",
    "data-name": "\\uD328\\uC2A4 121228",
    d: "M0,0H0V0Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 43.129, 136.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121229",
    "data-name": "\\uD328\\uC2A4 121229",
    d: "M0,0Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 41.79, 133.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121232",
    "data-name": "\\uD328\\uC2A4 121232",
    d: "M.04,0,.007.007,0,.037Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 35.563, 133.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121233",
    "data-name": "\\uD328\\uC2A4 121233",
    d: "M0,0,0,.052l.052,0Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 35.484, 135.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121234",
    "data-name": "\\uD328\\uC2A4 121234",
    d: "M.013,0,.006,0H.013Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 39.466, 132.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121243",
    "data-name": "\\uD328\\uC2A4 121243",
    d: "M0,0,.008.01H.024Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 37.113, 136.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121244",
    "data-name": "\\uD328\\uC2A4 121244",
    d: "M0,.007H0C0-.006,0,0,0,0v0H0Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 36.571, 135.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121246",
    "data-name": "\\uD328\\uC2A4 121246",
    d: "M.006.036.013.017,0,0Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 38.724, 135.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121265",
    "data-name": "\\uD328\\uC2A4 121265",
    d: "M.1.207A.1.1,0,1,0,0,.1.1.1,0,0,0,.1.207Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 35.964, 132.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121267",
    "data-name": "\\uD328\\uC2A4 121267",
    d: "M0,0H0V0H0Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 35.806, 132.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121269",
    "data-name": "\\uD328\\uC2A4 121269",
    d: "M0,0H0v0C0,0,0,0,0,0Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 35.89, 134.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121389",
    "data-name": "\\uD328\\uC2A4 121389",
    d: "M0,0H0L0,.006Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 32.325, 137.161)",
    fill: "#096473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121391",
    "data-name": "\\uD328\\uC2A4 121391",
    d: "M0,0C.007.039.013.078.021.117.017.1.013.074.009.053Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 25.782, 167.194)",
    fill: "#096473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121394",
    "data-name": "\\uD328\\uC2A4 121394",
    d: "M.04.048,0,0,.016.019Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 24.087, 161.944)",
    fill: "#096473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121397",
    "data-name": "\\uD328\\uC2A4 121397",
    d: "M.024.176l0-.011C.048.11.069.055.089,0L.021.184,0,.241.026.171A.019.019,0,0,0,.024.176Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 30.473, 138.557)",
    fill: "#096473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121400",
    "data-name": "\\uD328\\uC2A4 121400",
    d: "M0,0Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 29.74, 141.471)",
    fill: "#096473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121402",
    "data-name": "\\uD328\\uC2A4 121402",
    d: "M.017.056,0,.1C.013.069.026.035.038,0A.38.38,0,0,0,.017.056Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 28.068, 146.486)",
    fill: "#096473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121406",
    "data-name": "\\uD328\\uC2A4 121406",
    d: "M0,.026V.015A.051.051,0,0,0,0,.026Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 26.442, 167.561)",
    fill: "#096473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121422",
    "data-name": "\\uD328\\uC2A4 121422",
    d: "M0,8.083,83.7,8.5,83.732.419.029,0Z",
    transform: "translate(173.606 150.07) rotate(132)",
    fill: "#dfeaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121423",
    "data-name": "\\uD328\\uC2A4 121423",
    d: "M3.818.012.434,0A.408.408,0,0,0,.028.4L0,8.149a.4.4,0,0,0,.4.406l3.385.012a.405.405,0,0,0,.4-.4L4.222.418A.406.406,0,0,0,3.818.012Z",
    transform: "translate(176.596 147.122) rotate(132)",
    fill: "#05467e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121424",
    "data-name": "\\uD328\\uC2A4 121424",
    d: "M.011,2.448,0,5.63A2.454,2.454,0,0,0,2.44,8.083l4.7.017L7.169.017,2.471,0A2.454,2.454,0,0,0,.011,2.448Z",
    transform: "translate(181.217 141.674) rotate(132)",
    fill: "#fee0d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153188",
    "data-name": "\\uC0AC\\uAC01\\uD615 153188",
    width: 1.348,
    height: 83.879,
    transform: "translate(172.403 147.87) rotate(42)",
    fill: "#05467e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121425",
    "data-name": "\\uD328\\uC2A4 121425",
    d: "M0,1.347l83.879.418,0-1.348L0,0Z",
    transform: "translate(171.093 147.825) rotate(132)",
    fill: "#05467e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121426",
    "data-name": "\\uD328\\uC2A4 121426",
    d: "M0,1.346l83.878.419L83.884.417,0,0Z",
    transform: "translate(169.198 146.104) rotate(132)",
    fill: "#05467e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121427",
    "data-name": "\\uD328\\uC2A4 121427",
    d: "M.833,0C.833.673.023.67.02,1.343s.805.675.8,1.348-.81.67-.813,1.343.805.675.8,1.348S0,6.056,0,6.729s.805.68.8,1.353l9.6-2.374L16.9,4.1,10.227,2.4Z",
    transform: "translate(117.825 211.397) rotate(132)",
    fill: "#fee0d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121428",
    "data-name": "\\uD328\\uC2A4 121428",
    d: "M0,1.49A3.892,3.892,0,0,0,.46,3.309L6.964,1.7.287,0A3.759,3.759,0,0,0,0,1.49Z",
    transform: "translate(109.393 217.176) rotate(132)",
    fill: "#05467e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.a8a2068094402cfcf017c9c0d35c6a18.svg";
export { ForwardRef as ReactComponent };